
import { Component, Vue } from 'vue-property-decorator';
import { layoutConfig } from '@/store/getters/app_config';
import { get } from '@/lib/helpers';

@Component({
  components: {},
})
export default class NotFound extends Vue {
  private runHome() {
    this.$router.push({ name: get(layoutConfig(), 'routes.login', 'login') });
  }
}
